import { Grid } from '@material-ui/core';
import { FormHookResult, FormValueTypes } from 'design-system';
import { AnyAction } from 'redux';
import CatalogItem from 'src/models/helperTypes/CatalogItem';
import { makeLicensePlateComponent } from '../../ClientForm/functions';
import makeFormStyles from '../../styles/makeFormStyles';
import { onlyNumberAndLetter } from '../makeValidationSchema';

type Props = {
  getInputProps: FormHookResult;
  updateMultipleInputs: (newInputData: {
    [key: string]: FormValueTypes;
  }) => void;
  getCarDetailsFromLicenseAction: (
    param: string,
    param2: string,
  ) => Promise<AnyAction>;
  cleanCarDetailsFromLicense: () => void;
  setDisabled: (value: boolean) => void;
};

const LicensePlateSection = ({
  getInputProps,
  updateMultipleInputs,
  getCarDetailsFromLicenseAction,
  cleanCarDetailsFromLicense,
  setDisabled,
}: Props): JSX.Element => {
  const classes = makeFormStyles();
  const debounced = (
    carCategoryLicensePlate: string,
    carLicensePlate: string,
  ) => {
    setTimeout(() => {
      getCarDetailsFromLicenseAction(carCategoryLicensePlate, carLicensePlate);
      setDisabled(false);
    }, 1700);
  };

  /** Updates some Form items with data from Equifax, filter by the licensePlate */
  function onChangeLicensePlate(val: string) {
    if (val.length > 6 || !onlyNumberAndLetter(val)) return;
    const newVal = val.toUpperCase();
    getInputProps('carLicensePlate').onChange(newVal);
    const carCategoryLicensePlate = getInputProps('carCategoryLicensePlate')
      .value as string;
    if (val.length === 6 && carCategoryLicensePlate) {
      debounced(carCategoryLicensePlate, newVal);
    }
  }

  /** Updates some Form items when noLicense is selected */
  function onChangeNoLicensePlate(val: boolean) {
    cleanCarDetailsFromLicense();
    getInputProps('noLicensePlate').onChange(val);
    setDisabled(true);
    updateMultipleInputs({
      carModel: '',
      carLicensePlate: '',
      carCategoryLicensePlate: '',
      carYear: '',
      carBrand: '',
      passengersQty: '',
      fuel: '',
      color: '',
    });
  }

  /** Updates the some Form items with data from Equifax filter by the licensePlate */
  function onChangeCategoryLicensePlate(val: CatalogItem) {
    getInputProps('carCategoryLicensePlate').onChange(val.Value);
    const carLincensePlate = getInputProps('carLicensePlate').value as string;
    if (carLincensePlate.length === 6) {
      debounced(val.Value, carLincensePlate);
    }
  }

  return (
    <Grid item xs={12} sm={8} md={12}>
      {makeLicensePlateComponent({
        label: 'Placa',
        key: 'carLicensePlate',
        getInputProps,
        id: 'sales-web-inspection-input-licensePlate',
        classes,
        onChangeLicensePlate,
        onChangeCategoryLicensePlate,
        onChangeNoLicensePlate,
      })}
    </Grid>
  );
};

export default LicensePlateSection;
